import { ReactElement } from 'react';
import { Price as PriceComponent, PRICE_SIZE, PRICE_STYLE_TYPE } from '@lib/components/Price';
import { DataAttributesType } from '@lib/utils/getComponentDataAttributes';
import classNames from 'classnames';
import './Price.scss';

type Props = {
  currency?: string;
  children?: ReactElement;
  dataAttributes?: DataAttributesType;
  price: number | undefined;
  label?: string;
  styleType?: PRICE_STYLE_TYPE;
  className?: string;
  labelClassName?: string;
};

export const Price = ({
  children,
  price,
  currency,
  label,
  styleType,
  className,
  labelClassName,
  dataAttributes,
}: Props): ReactElement => {
  if (!price && !children) {
    return <></>;
  }

  return (
    <div className={classNames('CartProductPrice', className)}>
      <span className={classNames('CartProductPrice-Label', labelClassName)}>{label}</span>

      {children || (
        <PriceComponent
          dataAttributes={dataAttributes}
          currency={currency}
          price={price}
          size={PRICE_SIZE.small}
          styleType={styleType}
          className='CartProductPrice-Component'
        />
      )}
    </div>
  );
};
